var React = require('react');

function BigTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M577 -240.834L577 7.60678L0.731982 318.259L0.73196 69.8187L577 -240.834Z","fill":"#444444"}));
}

BigTop.defaultProps = {"width":"577","height":"319","viewBox":"0 0 577 319","fill":"none"};

module.exports = BigTop;

BigTop.default = BigTop;
